const DEFAULT_FLOW = 'default';

function toFlowSet(flowExpr: unknown): Set<string> {
    const raw = typeof flowExpr === 'string' ? flowExpr.trim() : '';
    if (!raw) return new Set([DEFAULT_FLOW]);

    const parts = raw
        .split(/[+|]/g)
        .map((p) => p.trim())
        .filter(Boolean);

    return new Set(parts.length ? parts : [DEFAULT_FLOW]);
}

export function doesRuleApplyToFlow(ruleFlowExpr: string | undefined, activeFlowExpr: unknown): boolean {
    const activeFlows = toFlowSet(activeFlowExpr);
    const ruleFlows = ruleFlowExpr ? toFlowSet(ruleFlowExpr) : new Set([DEFAULT_FLOW]);

    const ruleFlowList = Array.from(ruleFlows);
    for (let i = 0; i < ruleFlowList.length; i++) {
        const f = ruleFlowList[i];
        if (activeFlows.has(f)) return true;
    }
    return false;
}

export function isDefaultOnlyFlow(activeFlowExpr: unknown): boolean {
    const activeFlows = toFlowSet(activeFlowExpr);
    return activeFlows.size === 1 && activeFlows.has(DEFAULT_FLOW);
}
